export default __webpack_public_path__ + "static/media/currency.2d01608d.svg";